export default "__VITE_ASSET__CSt0Obsm__"